var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn-toggle',_vm._g({attrs:{"multiple":"","value":_vm.value}},_vm.$listeners),_vm._l((_vm.items),function(item){return _c('v-btn',{key:item.value,attrs:{"small":"","outlined":"","value":item.value}},[(item.icon)?_c('v-icon',[_vm._v(_vm._s(item.icon))]):_vm._e(),[_vm._v(_vm._s(item.label))]],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }